// Liste chiuse per il Simulatore Costi Dipendente.
// Fornite dall'utente — non aggiungere voci senza conferma.
// La lista originale mescola CCNL puri e tipologie/forme di rapporto: qui sono
// classificati in due gruppi per permettere combinazioni realistiche
// (es. "CCNL Agricolo + Tirocinante") e per dare al prompt LLM input piu' strutturati.

export const CCNL_OPTIONS = [
    { value: "CCNL Coop. Sociali - educativo", label: "CCNL Coop. Sociali - educativo" },
    { value: "CCNL Coop. Sociali - lavorativo", label: "CCNL Coop. Sociali - lavorativo" },
    { value: "CCNL Centri Esterni", label: "CCNL Centri Esterni" },
    { value: "CCNL Fise Assoambiente", label: "CCNL Fise Assoambiente" },
    { value: "CCNL Agricolo", label: "CCNL Agricolo" }
];

export const TIPOLOGIA_OPTIONS = [
    { value: "Standard", label: "Standard (rapporto subordinato)" },
    { value: "Tirocinante", label: "Tirocinante" },
    { value: "Volontario", label: "Volontario" },
    { value: "Convenzione CT", label: "Convenzione CT" },
    { value: "Coltivare Fraternita", label: "Coltivare Fraternità" },
    { value: "Azienda Esterna", label: "Azienda Esterna" }
];

export const REGIONI_ITALIA = [
    "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna",
    "Friuli-Venezia Giulia", "Lazio", "Liguria", "Lombardia", "Marche",
    "Molise", "Piemonte", "Puglia", "Sardegna", "Sicilia",
    "Toscana", "Trentino-Alto Adige", "Umbria", "Valle d'Aosta", "Veneto"
].map(r => ({ value: r, label: r }));

// Tipologie calcolate con le regole fiscali (backend/services/simulatoreCostiService.js).
// Le altre restano sulla stima AI e usano ancora RAL + regione.
export const TIPOLOGIE_A_REGOLE = ["Standard"];

// Parametri avanzati del calcolo a regole, raggruppati come nel file di Damiano.
// "unita'": perc = il backend vuole la frazione (0.279) ma il form mostra la percentuale (27,9);
//           eur / ore / giorni / num = valore cosi' com'e'.
// I valori di default arrivano dal backend (GET /ai-agents/simulatore-config).
export const PARAMETRI_GRUPPI = [
    {
        titolo: "Contributi e costi azienda",
        campi: [
            { key: "aliquotaIvs", label: "Contributi a carico lavoratore (IVS)", unita: "perc" },
            { key: "aliquotaInps", label: "INPS a carico azienda", unita: "perc" },
            { key: "aliquotaInail", label: "INAIL", unita: "perc" },
            { key: "aliquotaPrevidenzaCompl", label: "Previdenza complementare", unita: "perc" },
            { key: "assistenzaSanitariaAnnua", label: "Assistenza sanitaria (annua)", unita: "eur" },
            { key: "percIndennitaTurno", label: "Indennità turno", unita: "perc" },
            { key: "percIrap", label: "IRAP", unita: "perc" },
            // Vuoto = da CCNL (Coop Sociali: mezza mensilità, come nelle buste reali)
            { key: "quotaQuattordicesima", label: "Quattordicesima (0,5 = metà mensilità, 1 = intera; vuoto = da CCNL)", unita: "num" },
            { key: "mesePagamentoQuattordicesima", label: "Mese di pagamento della 14ª (1-12)", unita: "num" }
        ]
    },
    {
        titolo: "Fisco",
        campi: [
            // L'addizionale regionale si calcola dalla regione scelta (tabella MEF 2026 nel backend)
            { key: "aliquotaAddizionaleComunale", label: "Addizionale comunale", unita: "perc" },
            { key: "detrazioniFamiliariMensili", label: "Detrazioni familiari a carico (al mese)", unita: "eur" },
            // Vuoto = aumento della tabella livelli (rinnovo CCNL del 26/01/2024)
            { key: "aumentoRinnovo", label: "Aumento da rinnovo CCNL, al mese a tempo pieno (vuoto = da tabella)", unita: "eur" }
        ]
    },
    {
        titolo: "Orario e monte ore",
        campi: [
            { key: "oreFullTime", label: "Ore settimanali a tempo pieno", unita: "ore" },
            { key: "giorniSettimanali", label: "Giorni lavorati a settimana", unita: "giorni" },
            { key: "oreMensiliContrattuali", label: "Ore mensili contrattuali", unita: "ore" },
            { key: "giorniFerie", label: "Ferie", unita: "giorni" },
            { key: "giorniExFestivita", label: "Ex festività", unita: "giorni" },
            { key: "giorniFestivi", label: "Festivi infrasettimanali", unita: "giorni" },
            { key: "giorniMalattia", label: "Malattia, gravidanza, infortuni", unita: "giorni" },
            { key: "orePermessi", label: "Permessi", unita: "ore" },
            { key: "oreAssemblee", label: "Assemblee sindacali", unita: "ore" },
            { key: "oreDirittoStudio", label: "Diritto allo studio", unita: "ore" },
            { key: "oreFormazione", label: "Formazione professionale", unita: "ore" },
            { key: "oreFormazioneSicurezza", label: "Formazione sicurezza (D.Lgs 81/08)", unita: "ore" }
        ]
    }
];

export const UNITA_LABEL = { perc: "%", eur: "€", ore: "ore", giorni: "gg", num: "" };

// Imposta sostitutiva 5% sugli aumenti da rinnovo CCNL (L. 199/2025): spetta con reddito 2025 fino a
// 33.000 €, salvo rinuncia. "auto" = il backend la applica se il reddito simulato e' sotto la soglia.
export const SOSTITUTIVA_OPTIONS = [
    { value: "auto", label: "Automatico (in base al reddito simulato)" },
    { value: "si", label: "Sì — reddito 2025 fino a 33.000 €" },
    { value: "no", label: "No — reddito 2025 oltre 33.000 € o rinuncia" }
];

// Mese della busta: le detrazioni si calcolano sui giorni del mese (come il gestionale paghe),
// a dicembre c'e' la 13ª, nel mese della 14ª la 14ª. 0 = "mese tipo" (media dell'anno).
export const MESI_OPTIONS = [
    { value: 0, label: "Mese tipo (media dell'anno)" },
    ...["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto",
        "Settembre", "Ottobre", "Novembre", "Dicembre"].map((m, i) => ({ value: i + 1, label: `${m} 2026` }))
];
